// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  height: -moz-fit-content;
  height: fit-content;
  background-color: white;
  border-radius: 15px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  margin: 0px;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/widgets/widget-finance/widget-finance.component.scss"],"names":[],"mappings":"AAAA;EACI,wBAAA;EAAA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iDAAA;EACA,WAAA;EACA,mBAAA;AACJ","sourcesContent":["ion-card{\r\n    height: fit-content;\r\n    background-color: white;\r\n    border-radius: 15px;\r\n    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n    margin: 0px;\r\n    white-space: nowrap;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
